import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
  makeStyles, Card, CardContent, TextField, MenuItem, FormControl, InputLabel,
  Select, Typography, Button, CircularProgress,
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useSelector, useDispatch } from 'react-redux';

import { Auth0Context } from '../../utils/auth0';
import {
  selectOrganizations, registerPhysician, loadOrganizations,
} from '../../store/slices/organizationsSlice';

export default function PhysiciansScreen() {
  const classes = useStyles();
  const { getAccessTokenSilently } = useAuth0() as Auth0Context;

  const dispatch = useDispatch();
  const {
    loading, error, organizations, registeredPhysician,
  } = useSelector(selectOrganizations);

  const [email, setEmail] = useState('');
  const [organizationId, setOrganizationId] = useState(1);

  useEffect(() => {
    if (organizations == null) {
      dispatch(loadOrganizations(getAccessTokenSilently));
    }
  }, []);

  return (
    <div className={classes.container}>
      <Card>
        <CardContent>
          <Typography variant="h6">
            Create a Physician Account
          </Typography>
          <div className={classes.formContainer}>
            <TextField
              autoFocus
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              label="Email"
              type="email"
              className={classes.formControl}
            />
            <FormControl className={classes.formControl}>
              <InputLabel id="register-physician-organization-label">
                Organization
              </InputLabel>
              <Select
                labelId="register-physician-organization-label"
                value={organizationId}
                onChange={(event) =>
                  setOrganizationId(parseInt(event.target.value as string))}
              >
                {organizations == null && (
                  <MenuItem disabled>Loading...</MenuItem>
                )}
                {(organizations || []).map((organization) => (
                  <MenuItem key={organization.id} value={organization.id}>
                    {organization.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div className={classes.registerButtonContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  dispatch(registerPhysician({
                    email,
                    organizationId,
                  }, getAccessTokenSilently))}
                disabled={loading}
              >
                Create
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  color="primary"
                  className={classes.registerButtonProgress}
                />
              )}
            </div>
          </div>
          {registeredPhysician != null && (
            <Typography className={classes.success}>
              <CheckCircleIcon />
              Physician registered. Password: {registeredPhysician.password}
            </Typography>
          )}
          {error != null && (
            <Typography className={classes.error} color="error">
              An error has occurred.
            </Typography>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(3) + 64,
  },
  formContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1),
  },
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 120,
  },
  registerButtonContainer: {
    position: 'relative',
    display: 'inline-block',
  },
  registerButtonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  success: {
    marginTop: theme.spacing(2),
    color: theme.palette.success.main,
    '& svg': {
      position: 'relative',
      top: 6,
      marginRight: theme.spacing(1),
    },
  },
  error: {
    marginTop: theme.spacing(2),
  },
}));
